var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.5V13.8333L2.16667 12.1667V15.5H0.5ZM3.83333 15.5V10.5L5.5 8.83333V15.5H3.83333ZM7.16667 15.5V8.83333L8.83333 10.5208V15.5H7.16667ZM10.5 15.5V10.5208L12.1667 8.85417V15.5H10.5ZM13.8333 15.5V7.16667L15.5 5.5V15.5H13.8333ZM0.5 11.1875V8.83333L6.33333 3L9.66667 6.33333L15.5 0.5V2.85417L9.66667 8.6875L6.33333 5.35417L0.5 11.1875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e0fc34b0832566f53f822f7224701780.svg";
export { ForwardRef as ReactComponent };